import React from "react";
import {
  Shield,
  Database,
  TrendingUp,
  Info,
  BarChart2,
  Search,
  Eye,
  Target,
  AlertTriangle,
} from "lucide-react";
import { isRateLimited, getRateLimitMessage } from "../../services/fmpService";

const IntroScreen = ({ onStart }) => {
  // Check if we're currently rate limited
  const rateLimited = isRateLimited();
  const rateLimitMessage = getRateLimitMessage();

  return (
    <div className="insights-intro-container">
      <div className="insights-intro-card">
        <div className="intro-header">
          <Shield size={48} className="intro-icon" />
          <h2>Value Insights</h2>
        </div>

        {rateLimited ? (
          <div className="rate-limit-warning">
            <AlertTriangle size={48} className="limit-icon" />
            <h3>Service Temporarily Unavailable</h3>
            <p>
              {rateLimitMessage ||
                "Maximum daily API requests have been reached. Please try again in a few minutes."}
            </p>
          </div>
        ) : (
          <>
            <div className="intro-description">
              <p>
                Welcome to Value Insights, your advanced tool for discovering
                undervalued stocks and analyzing investment opportunities based
                on intrinsic value metrics.
              </p>

              <div className="features-list">
                <div className="feature-item">
                  <BarChart2 size={20} className="feature-icon" />
                  <div className="feature-text">
                    <h4>Market Overview</h4>
                    <p>
                      Sector performance, market trends, and value opportunities
                    </p>
                  </div>
                </div>

                <div className="feature-item">
                  <Search size={20} className="feature-icon" />
                  <div className="feature-text">
                    <h4>Value Stock Screener</h4>
                    <p>
                      Filter stocks by discount to intrinsic value, financial
                      metrics, and more
                    </p>
                  </div>
                </div>

                <div className="feature-item">
                  <Target size={20} className="feature-icon" />
                  <div className="feature-text">
                    <h4>Stock Analysis</h4>
                    <p>
                      Deep dives into valuation, safety ratings, and financial
                      metrics
                    </p>
                  </div>
                </div>

                <div className="feature-item">
                  <Eye size={20} className="feature-icon" />
                  <div className="feature-text">
                    <h4>Investment Insights</h4>
                    <p>Strengths, weaknesses, and actionable recommendations</p>
                  </div>
                </div>
              </div>

              <div className="usage-tips">
                <Info size={20} className="tips-icon" />
                <div className="tips-text">
                  <h4>Usage Tips</h4>
                  <ul>
                    <li>Data is loaded once when you start the analysis</li>
                    <li>
                      Use the search function to find specific stocks instead of
                      browsing
                    </li>
                    <li>Stock data will be cached to improve performance</li>
                    <li>
                      Detailed data is loaded only when you select a specific
                      stock
                    </li>
                  </ul>
                </div>
              </div>
            </div>

            <button className="start-analysis-button" onClick={onStart}>
              <TrendingUp size={20} />
              <span>Start Market Analysis</span>
            </button>
          </>
        )}
      </div>
    </div>
  );
};

export default IntroScreen;
